export default __webpack_public_path__ + "static/media/icn-cobotics-cadastro-clientes.88ab2d45.svg";